<template>
  <article class="share__sku">
    <p class="title">以下商品用券立享优惠</p>
    <ul>
      <li v-for="item in skuList" :key="item.wareId" @click="jump(item.wareId,item)">
        <div class="sku__img">
          <img :src="item.content.img | image(172,140)">
        </div>
        <div class="sku__price">
          <p class="sku__name" :title="decodeURIComponent(item.content.warename)">
            {{decodeURIComponent(item.content.warename)}}</p>
          <p class="sku__money ellipse">
            <span class="newMoney">
              ￥<label class="big">{{item.dredisprice | priceSplit(0)}}</label>
              <label>.{{item.dredisprice | priceSplit(1)}}</label>
            </span>
            <span class="oldMoney">{{item.commentcount | moneyUnit }}条评价</span>
          </p>
        </div>
      </li>
    </ul>
    <jm-infinite-load ref="loadmore" @loadmore="loadmore" :loading="loading" />
  </article>
</template>

<script>
// Color API迁移：引入Color网关相关配置和方法
// appId: Color应用标识符，用于接口认证
// fetchColorGetForCustom: 自定义Color网关请求方法，支持灰度发布
// LOGIN_TYPE: 登录方式标识(H5=2)，用于Color网关参数构建
import {appId, fetchColorGetForCustom, LOGIN_TYPE} from "@/plugins/axiosColor";

export default {
  props: ['couponType', 'prize', 'inviteId'],
  data () {
    return {
      skuList: [],
      pageNumber: 1,
      pageSize: 40,
      loading: false
    }
  },
  methods: {
    async getSkuInfo () {
      let data = {
        appid: appId,                                          // Color应用标识
        functionId: 'interact_share_fission_getCouPonInfo',   // 业务功能标识
        t: new Date().getTime(),                              // 请求时间戳，防重放攻击
        body: JSON.stringify({
          couponType: this.couponType,
          otherKey: this.inviteId,
          pageNum: this.pageNumber++,
          searchId: this.prize.prizeId,
          size: this.pageSize,
        }),                           // 原始业务参数序列化
        loginType: LOGIN_TYPE,                                // H5登录类型(2)
        client: 'H5',                                         // 客户端类型标识
        clientVersion: '10.2.23'                             // 客户端版本号
      }
      let PSign = null
      if (window.ParamsSign) {
        PSign = new window.ParamsSign({
          appId: '842ea',
          preRequest: true,
          debug: false // 测试时开启调试，切记：上线后设置为false
        })
      }
      let { h5st, _stk } = await PSign.sign(data)
      data = { ...data, h5st: encodeURI(h5st), _stk }
      // fetchColorGetForCustom: 新的Color网关请求方法，支持多环境和统一错误处理
      // this.$axios.post: 原有网关请求方法，保持向下兼容
      const getCouPonInfoApi = fetchColorGetForCustom(data)
      getCouPonInfoApi.then(res => {
        res = JSON.parse(res);
        if (res.length !== 0) {
          res.forEach(item => {
            item.content = JSON.parse(item.content)
            item.content.img = item.content.imageurl || item.content.trans_img_url
          })
          this.skuList = this.skuList.concat(res)
          setTimeout(() => {
            let nodeList = document.querySelectorAll(".share__sku .sku__img img");
            let nodeLen = nodeList.length;
            for (let i = 0; i < nodeLen; i++) {
              let src = nodeList[i].getAttribute("src");
              let src2x = src.replace(/[s](\d{3})[x](\d{3})_jfs/, 's344x280_jfs');
              let src3x = src.replace(/[s](\d{3})[x](\d{3})_jfs/, 's516x420_jfs');
              nodeList[i].setAttribute("srcset", `${src2x} 2x, ${src3x}  3x`)
            }
            this.loading = false
          }, 500)
        } else {
          this.$refs.loadmore.loadEnd()
        }

      }).catch(res => {
        this.$toast({
          iconName: 'warning',
          msg: res.message
        });
        this.$refs.loadmore.loadError()
      })
    },
    jump (id, item) {
      this.bury("share_coupon_1571229562021|14", JSON.stringify(item))
      location.href = `https://item.m.jd.com/ware/view.action?wareId=${id}&sid=null`
    },
    loadmore () {
      this.loading = true
      this.getSkuInfo();
    }
  },
  mounted () {
    // this.getSkuInfo()
  }
}
</script>

<style lang="scss" scoped>
.share__sku {
  margin-top: 13px;
  ul {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    padding-left: 10px;
    li {
      width: 172px;
      height: 225px;
      border-radius: 7px;
      overflow: hidden;
      margin: 10px 5px;
      cursor: pointer;
      display: inline-block;
      background: #fff;
      box-shadow: 0 2px 20px 0 #E6E6E6;
      .sku__img {
        height: 140px;
        img {
          width: 172px;
          height: 140px;
        }
      }
      .sku__price {
        height: 85px;
        padding: 10px;
        .sku__name {
          position: relative;
          word-break: break-all;
          font-size: 12px;
          color: #333333;
          line-height: 17px;
          max-height: 34px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .sku__money {
          margin-top: 10px;
          display: flex;
          text-align: justify;
          height: 17px;
          line-height: 17px;
          align-items: baseline;
          .newMoney {
            display: flex;
            font-size: 12px;
            color: #E82C07;
            line-height: 17px;
            font-weight: 600;
            align-items: baseline;

            .big {
              font-size: 18px;
            }
          }
          .oldMoney {
            font-size: 12px;
            margin-left: 10px;
            color: #cccccc;
          }
        }
      }
    }
  }
}
</style>
